/**
 * Logo Slider Block JavaScript
 */
class LogoSlider {

	/**
	 * Static container width for marquee calculations
	 * @type {number}
	 * This is used to determine how many clones are needed for smooth scrolling
	 */
	static containerWidth = 1440;

	/**
	 * Buffer for marquee clones to ensure smooth scrolling
	 * @type {number}
	 */
	static cloneBuffer = 2;

	/**
	 * Initialize LogoSlider functionality for all LogoSlider blocks
	 */
	static init() {

		document.querySelectorAll( '.b-logo-slider' ).forEach( slider => new LogoSlider( slider ) );

	}

	/**
	 * Constructor for LogoSlider class
	 * @param {HTMLElement} element The LogoSlider block element
	 */
	constructor( element ) {

		this.element = element;
		this.resizeTimeout = null;
		this.scrollEl = this.element.querySelector( '.js-logo-slider-scroll' );
		this.breakpoint = parseInt( this.element.dataset.breakpoint || 768, 10 );

		this.initialize();
		this.setupEventListeners();

	}

	/**
	 * Initialize the logo slider
	 */
	initialize() {

		this.handleResponsiveLayout();

	}

	/**
	 * Setup event listeners
	 */
	setupEventListeners() {

		window.addEventListener( 'resize', () => {

			clearTimeout( this.resizeTimeout );
			this.resizeTimeout = setTimeout( () => this.handleResponsiveLayout(), 250 );

		} );

	}

	/**
	 * Check if we should show grid or slider based on layout and screen width
	 * @return {string} - 'grid' or 'slider'
	 */
	getCurrentMode() {

		const isSmallScreen = window.innerWidth < this.breakpoint;

		if ( isSmallScreen ) {

			return 'slider';

		}

		const isGridLayout = this.element.classList.contains( 'b-logo-slider--layout-grid' );
		return isGridLayout ? 'grid' : 'slider';

	}

	/**
	 * Update animation duration and handle marquee cloning
	 */
	updateAnimationDuration() {

		const currentMode = this.getCurrentMode();
		if ( currentMode === 'grid' || !this.scrollEl ) {

			return;

		}

		const marqueeScroll = this.scrollEl.querySelector( '.js-logo-slider-marquee' );
		const marquee = this.scrollEl.querySelector( '.js-logo-slider-marquee-item' );
		if ( !marquee || !marqueeScroll ) {

			return;

		}

		// Remove all existing clones
		marqueeScroll.querySelectorAll( '.js-logo-slider-marquee-item.clone' ).forEach( clone => {

			clone.parentNode.removeChild( clone );

		} );

		const isAlwaysAnimate = this.element.classList.contains( 'b-logo-slider--always-animate' );
		const isContentWiderThanContainer = marquee.offsetWidth > marqueeScroll.offsetWidth;
		const shouldAnimate = isAlwaysAnimate || isContentWiderThanContainer;

		if ( shouldAnimate ) {

			const allMarqueeItems = marqueeScroll.querySelectorAll( '.js-logo-slider-marquee-item' );
			allMarqueeItems.forEach( item => item.classList.remove( 'b-logo-slider__marquee-item--play' ) );
			void marquee.offsetWidth;
			setTimeout( () => {

				marqueeScroll.querySelectorAll( '.js-logo-slider-marquee-item' ).forEach( item => {

					item.classList.add( 'b-logo-slider__marquee-item--play' );

				} );

			}, 10 );

			if ( isAlwaysAnimate && ! isContentWiderThanContainer  ) {

				const containerWidth = LogoSlider.containerWidth;
				const itemWidth = marquee.offsetWidth;
				const buffer = LogoSlider.cloneBuffer;
				const totalNeededWidth = containerWidth * buffer;
				const clonesNeeded = Math.ceil( totalNeededWidth / itemWidth ) - 1;

				for ( let i = 0; i < clonesNeeded; i++ ) {

					const clone = marquee.cloneNode( true );
					clone.classList.add( 'clone' );
					marqueeScroll.appendChild( clone );

				}

			} else {

				const marqueeClone = marquee.cloneNode( true );
				marqueeClone.classList.add( 'clone' );
				marqueeScroll.appendChild( marqueeClone );

			}

		} else {

			marqueeScroll.querySelectorAll( '.js-logo-slider-marquee-item' ).forEach( item => {

				item.classList.remove( 'b-logo-slider__marquee-item--play' );

			} );

		}

	}

	/**
	 * Handle responsive behavior and cleanup for grid mode
	 */
	handleResponsiveLayout() {

		if ( !this.scrollEl ) {

			return;

		}

		const marquee = this.scrollEl.querySelector( '.js-logo-slider-marquee-item' );
		const marqueeClone = this.scrollEl.querySelector( '.js-logo-slider-marquee-item.clone' );
		const currentMode = this.getCurrentMode();

		this.element.classList.remove( 'b-logo-slider--responsive-grid' );
		this.element.classList.remove( 'b-logo-slider--responsive-slider' );

		if ( currentMode === 'grid' ) {

			this.element.classList.add( 'b-logo-slider--responsive-grid' );

			if ( marquee ) {

				marquee.classList.remove( 'b-logo-slider__marquee-item--play' );

			}

			if ( marqueeClone && marqueeClone.parentNode ) {

				marqueeClone.parentNode.removeChild( marqueeClone );

			}

		} else {

			this.element.classList.add( 'b-logo-slider--responsive-slider' );

			setTimeout( () => {

				this.updateAnimationDuration();

			}, 10 );

		}

	}

}


document.addEventListener( 'DOMContentLoaded', LogoSlider.init );
